<template>
  <div class="entity-service-page">
    <!-- 宽屏(md≥992px)左右分栏便于对照输入与结果；窄屏自动上下堆叠 -->
    <el-row :gutter="12" class="entity-service-page__main-row" type="flex">
      <el-col :xs="24" :md="10" class="entity-service-page__col entity-input-col">
        <div class="grid-content bg-purple entity-service-page__col-inner">
          <el-card class="box-card entity-card entity-card--input" shadow="hover">
            <div slot="header" class="entity-card__header clearfix">
              <i class="el-icon-card-header"></i>
              <span class="entity-card__title">输入病历内容</span>
            </div>
            <div class="entity-card__body-inner entity-input-panel">
              <el-form
                ref="form"
                class="entity-form entity-form--column-fill"
                :model="textForm"
                label-position="top"
                size="mini"
              >
                <el-form-item label="病历内容" class="entity-form__item-textarea entity-form__item--flex-grow">
                  <el-input
                    class="entity-textarea entity-textarea--fill"
                    type="textarea"
                    :rows="1"
                    placeholder="请输入病历文本，点击「分析」进行实体抽取…"
                    v-model="textForm.content"
                  />
                </el-form-item>
                <el-form-item class="entity-form__actions">
                  <el-button
                    type="primary"
                    class="entity-btn-analyze"
                    :loading="analyzing"
                    @click="onSubmit"
                  >
                    分析
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :xs="24" :md="14" class="entity-service-page__col entity-result-col">
        <div class="grid-content bg-purple entity-service-page__col-inner">
          <el-card class="box-card entity-card entity-card--result" shadow="hover">
            <div slot="header" class="entity-card__header entity-card__header--accent clearfix">
              <i class="el-icon-card-header-red"></i>
              <span class="entity-card__title">解析结果</span>
            </div>
            <div class="entity-card__body-inner entity-result">
              <section class="entity-result__section">
                <b-card-text class="entity-result__label">所涉及疾病</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_disease"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
              <section class="entity-result__section">
                <b-card-text class="entity-result__label">所涉及治疗药物</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_med"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
              <section class="entity-result__section">
                <b-card-text class="entity-result__label">所涉及药物种类</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_med_cat"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
              <section class="entity-result__section">
                <b-card-text class="entity-result__label">所涉及治疗医学治疗手段</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_med_exam"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
              <section class="entity-result__section">
                <b-card-text class="entity-result__label">所涉及治疗方法</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_oper"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
              <section class="entity-result__section entity-result__section--last">
                <b-card-text class="entity-result__label">所涉及症状</b-card-text>
                <div class="entity-result__tags">
                  <el-tag
                    v-for="item in result_symp"
                    :key="item.label"
                    :type="item.type"
                    effect="dark"
                    class="entity-tag"
                  >
                    {{ item.name }}
                  </el-tag>
                </div>
              </section>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/main.css';

export default {
  name: "EntityService",
  data() {
    return {
      /** 点击「分析」后请求进行中，用于按钮 loading */
      analyzing: false,
      textForm: {
        content: '示例文本：用户主诉3：尿毒症患者，主要为口服碳酸氢钠，需在医生指导下调整用药剂量；必要时可静脉输入。一般口服磷结合剂，如碳酸钙、醋酸钙、司维拉姆、碳酸镧等。宝贝拉肚子到今天为止总共第几天了呢.怎么调，妈咪爱有吃这两天.吃着益生菌观察两天，大便次数大便性状不缓解或者加重及时带宝贝去儿内科就诊查大便常规明确一下病因，需不需要调整用药，根据结果对症处理，精神状态差，超过8小时没尿的话就可以及时带宝贝去儿内科就诊补液对症治疗了，防止宝贝脱水电解质紊乱的奥！发烧 咳嗽怎么办',
      },
      /** 以下为解析结果列表，仅用户点击「分析」并成功返回后赋值；初始为空数组，不进页即请求接口 */
      result_disease: [],
      result_med: [],
      result_med_cat: [],
      result_med_exam: [],
      result_oper: [],
      result_symp: [],

    };
  },
  methods: {
    /**
     * 提交病历内容，调用实体抽取接口并刷新下方各结果列表
     * 无入参，使用 this.textForm 作为请求体
     */
    onSubmit() {
      this.analyzing = true
      this.$http.post(process.env.VUE_APP_API_HOST + "/med_extract", this.textForm, {"content-type": "application/json"}).then((res) => {
        this.result_disease = res.data.dis || []
        this.result_med = res.data.med || []
        this.result_med_cat = res.data.med_cat || []
        this.result_med_exam = res.data.med_exam || []
        this.result_oper = res.data.oper || []
        this.result_symp = res.data.symp || []
      }).catch(() => {
        this.$message.error('解析请求失败，请稍后重试')
      }).finally(() => {
        this.analyzing = false
      })
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}
</script>

<style scoped>
/* 页面整体：留白、卡片间距、与深色侧栏协调 */
.entity-service-page {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  padding: 16px 10px 24px;
  box-sizing: border-box;
}

/* 与 el-row type="flex" 配合：两列等高拉伸 */
.entity-service-page__main-row {
  align-items: stretch;
}

.entity-service-page__col {
  display: flex;
  padding: 0;
}

.entity-service-page__col-inner {
  flex: 1;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

@media (max-width: 991px) {
  .entity-result-col {
    margin-top: 18px;
  }
}

.entity-card /deep/ .el-card__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: auto;
  min-height: 44px;
  padding: 10px 14px;
  background: linear-gradient(180deg, rgba(62, 66, 78, 0.95) 0%, rgba(54, 57, 68, 0.92) 100%);
}

.entity-card--result /deep/ .el-card__header {
  border-bottom-color: rgba(238, 102, 102, 0.2);
}

.entity-card /deep/ .el-card__body {
  background-color: #363944;
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.entity-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.entity-card__header {
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.entity-card__title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.92);
}

.entity-card__body-inner {
  padding: 14px 14px 16px;
  flex: 1;
  min-height: 0;
}

/* 左侧：纵向铺满卡片，文本域占满「扣除底部按钮区域」后的高度，操作栏贴底靠右 */
.entity-input-panel {
  display: flex;
  flex-direction: column;
  min-height: min(52vh, 560px);
}

.entity-form--column-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.entity-form__item--flex-grow {
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.entity-form__item--flex-grow /deep/ .el-form-item__content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.entity-textarea--fill {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.entity-textarea--fill /deep/ .el-textarea {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.entity-textarea--fill /deep/ .el-textarea__inner {
  height: 100% !important;
  min-height: 180px;
  resize: vertical;
  box-sizing: border-box;
}

.entity-form /deep/ .el-form-item__label {
  color: rgba(255, 255, 255, 0.72);
  padding-right: 0;
  padding-bottom: 6px;
  line-height: 1.3;
  width: 100% !important;
}

.entity-form__item-textarea /deep/ .el-form-item__content {
  line-height: 1.5;
}

.entity-textarea /deep/ textarea {
  font-size: 13px;
  line-height: 1.55;
  border-radius: 8px;
  background: #2d313a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.entity-textarea /deep/ textarea:focus {
  border-color: rgba(46, 205, 129, 0.55);
  box-shadow: 0 0 0 1px rgba(46, 205, 129, 0.25);
}

.entity-textarea /deep/ textarea::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.entity-form__actions {
  margin-bottom: 0;
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 12px;
}

.entity-form__actions /deep/ .el-form-item__content {
  display: flex;
  justify-content: flex-end;
}

.entity-btn-analyze {
  min-width: 104px;
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
  background-color: rgb(46, 205, 129) !important;
  border-color: rgb(46, 205, 129) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(46, 205, 129, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.entity-btn-analyze:hover,
.entity-btn-analyze:focus {
  filter: brightness(1.06);
  box-shadow: 0 6px 18px rgba(46, 205, 129, 0.45);
}

.entity-btn-analyze:active {
  transform: translateY(1px);
}

/* 解析结果：分区 + 标签换行；长列表时右侧列内滚动，避免整页过长 */
.entity-result {
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow-y: auto;
  max-height: min(70vh, 720px);
}

.entity-result__section {
  padding: 14px 14px 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.entity-result__section--last {
  margin-bottom: 2px;
}

.entity-result__label {
  display: inline-block;
  max-width: 100%;
  margin: 0 0 10px 0;
  padding-left: 10px;
  border-left: 3px solid rgba(46, 205, 129, 0.85);
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.4;
}

.entity-result__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
  align-items: center;
}

.entity-tag {
  margin: 0 !important;
  border-radius: 6px !important;
  border: none !important;
  font-size: 12px;
  padding: 0 11px;
  height: 28px;
  line-height: 28px;
}

/* 本页未使用表格，保留行样式以防后续扩展列表示例 */
.el-table /deep/ tbody tr:hover {
  color: black !important;
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3c3f4a;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}
</style>
